import React, { useEffect } from "react";
import { Card, Col, Container, Row } from "reactstrap";
import OrderListing from "./OrderListing";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const Orders = () => {
  const breadcrumbItems = [
    { title: "Order", link: "" },
    { title: "Order", link: "/order/orders" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card className="card_container">
            <OrderListing />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Orders;
